export default __webpack_public_path__ + "static/media/category.24f007cb.svg";